<script setup lang="ts">
import type { RadioEmits, RadioProps } from '/#/components/base/form/radio'

const props = withDefaults(defineProps<RadioProps>(), {
  id: undefined,
  modelValue: undefined,
  label: undefined,
  color: undefined,
  name: undefined,
  variant: 'checkmark',
})

const emit = defineEmits<RadioEmits>()

const fieldContext = reactive(
  useFieldContext({
    id: props.id,
    inherit: false,
  }),
)
const selectedValue = useVModel(props, 'modelValue', emit)
</script>

<template>
  <Label raw class="flex primary radio">
    <input
      :id="fieldContext.id"
      v-model="selectedValue"
      type="radio"
      :value="value"
      :name="name"
    />
    <span class="shrink-0">
      <i :class="variant" />
    </span>
    <slot v-bind="fieldContext">{{ label }}</slot>
  </Label>
</template>
